export default "__VITE_ASSET__DQFXvB5u__"